import { render } from "./social_feed.vue?vue&type=template&id=0b8ee666&scoped=true"
import script from "./social_feed.vue?vue&type=script&lang=js"
export * from "./social_feed.vue?vue&type=script&lang=js"

import "./social_feed.vue?vue&type=style&index=0&id=0b8ee666&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8ee666"]])

export default __exports__